import { DHeading } from './Heading'
import { Spacer } from '@/components/elements/Spacer'
import { IrSiteMapLink } from '@/components/layouts/SiteMap/IrSiteMapLink'

export const Footer = () => (
  <div>
    <DHeading>IRサイトマップ</DHeading>
    <Spacer h={{ sp: 30, pc: 60 }} />
    <IrSiteMapLink />
  </div>
)
